import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as modalDataService from './modalDataService';
import * as validationService from "./validationService";

function IpField({ mngtIpAddress, error, disabled }) {
    const isDuplicateError = error === 'This device IP already exists for this device type';

    useEffect(() => {
        if (disabled) {
            // If disabled, clear out the value in your data store
            modalDataService.changeIp('');
            // Clear any active validation errors for this field
            validationService.cleanValidation('mngtIpAddress');
            setTouched(false);
            return;
        }

        // Only run validation if the field is active
        validationService.validateIp(mngtIpAddress, 'mngtIpAddress')
        return () => validationService.cleanValidation('mngtIpAddress');
    }, [mngtIpAddress, disabled])

    const [touched, setTouched] = useState(false);

    const onChange = (value) => modalDataService.changeIp(value);

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="ip">IP Address / FQDN <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${(error && touched) && 'border-danger'}`}
                    id="ip"
                    value={disabled ? "" : mngtIpAddress}
                    placeholder={disabled ? "" : "192.168.1.100 or server.domain.com"}
                    disabled={disabled}
                    onFocus={() => setTouched(true)}
                    onChange={event => onChange(event.target.value)} />
                {isDuplicateError && (
                    <div className="text-danger mt-1">{error}</div>
                )}
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("HostNameField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    return {
        mngtIpAddress: addDeviceModal.mngtIpAddress || '',
        error: validation.mngtIpAddress
    }
}

export default connect(mapStateToProps)(IpField);
